import { useState } from "react";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router";
import { useToast } from "../../components/ui/Toast";
import {
  FaqEditor,
  emptyFaqFormValues,
  type FaqFormValues,
} from "./faq-edit/FaqEditor";
import { CREATE_FAQ } from "./faq-edit/faqMutations";

interface CreateResponse {
  createFaq: { id: string; question: string } | null;
}

export function FaqCreate() {
  const navigate = useNavigate();
  const toast = useToast();
  const [create, createResult] = useMutation<CreateResponse>(CREATE_FAQ, {
    refetchQueries: ["AllFaqsForListing"],
  });
  const [saveError, setSaveError] = useState<string | null>(null);

  async function handleSave(values: FaqFormValues) {
    setSaveError(null);
    try {
      const result = await create({
        variables: {
          question: values.question,
          answer: values.answer || null,
          sortOrder: values.sortOrder,
          showOnFaqPage: values.showOnFaqPage,
        },
      });
      const created = result.data?.createFaq;
      if (!created) throw new Error("Couldn't create FAQ");
      toast.push({
        kind: "success",
        title: "FAQ created",
        description: values.showOnFaqPage
          ? "Live on /faq."
          : "Saved as landing-only.",
      });
      navigate(`/website/faqs/${created.id}`, { replace: true });
    } catch (err) {
      const message = err instanceof Error ? err.message : "Unknown error";
      setSaveError(message);
      toast.push({
        kind: "error",
        title: "Couldn't create FAQ",
        description: message,
      });
    }
  }

  return (
    <FaqEditor
      mode="create"
      initialValues={emptyFaqFormValues()}
      isSaving={createResult.loading}
      saveError={saveError}
      onSave={handleSave}
    />
  );
}
